<template>
    <div class="main">
        <h1 class="title is-4 align-center">Features</h1>
        <div class="box" v-if="isReusableBagsFeature != null">
            <switch-button 
                label="Reusable bags" 
                v-model="isReusableBagsFeature"
                @onClick="updateFeature('reusable_bags', $event)"></switch-button>
        </div>
        <div class="box" v-if="isDisplayDietaryRequirement != null">
            <switch-button
                label="Display dietary requirements (Halal)"
                v-model="isDisplayDietaryRequirement"
                @onClick="updateFeature('display_dietary_requirement', $event)"></switch-button>
        </div>
        <div class="box">
            <p class="label">Backfill name search tokens</p>
            <p class="help mb-3">One-time operation. Adds trigram tokens to all existing beneficiary records to enable case-insensitive substring name search.</p>
            <button
                class="button is-warning"
                :class="{ 'is-loading': isMigrating }"
                :disabled="isMigrating || migrationDone"
                @click="runNameTokenMigration"
            >
                {{ migrationDone ? 'Migration complete' : 'Run migration' }}
            </button>
            <p v-if="migrationResult" class="help mt-2 has-text-success">{{ migrationResult }}</p>
            <p v-if="migrationError" class="help mt-2 has-text-danger">{{ migrationError }}</p>
        </div>
    </div>
</template>

<script>
import SwitchButton from '@/components/ui/ToggleSwitch.vue';

export default {
    components: {
        SwitchButton
    },
    data() {
        return {
            isReusableBagsFeature: null,
            isDisplayDietaryRequirement: null,
            isMigrating: false,
            migrationDone: false,
            migrationResult: null,
            migrationError: null
        }
    },
    computed: {
        isReusableBagFeatureEnabled() {
            return this.$store.getters['configurations/isReusableBagFeatureEnabled'];
        },
        isDisplayDietaryRequirementEnabled() {
            return this.$store.getters['configurations/isDisplayDietaryRequirementEnabled'];
        },
    },
    mounted() {
        this.isReusableBagsFeature = this.isReusableBagFeatureEnabled;
        this.isDisplayDietaryRequirement = this.isDisplayDietaryRequirementEnabled;
    },
    watch: {
        isReusableBagFeatureEnabled(newValue) {
            this.isReusableBagsFeature = newValue; // Update local data when computed changes
        },
        isDisplayDietaryRequirementEnabled(newValue) {
            this.isDisplayDietaryRequirement = newValue; // Update local data when computed changes
        }
    },
    methods: {
        async updateFeature(featureKey, newValue) {
            console.log("updating firebase: [" + featureKey + "] -> [" + newValue + "]");
            try {
                await this.$store.dispatch('configurations/updateFeature', {
                    featureKey: featureKey,
                    newValue: newValue
                });
            } catch(error) {
                console.log(error);
            }
        },
        async runNameTokenMigration() {
            this.isMigrating = true;
            this.migrationResult = null;
            this.migrationError = null;
            try {
                const count = await this.$store.dispatch('beneficiary/migrateBeneficiaryNameTokens');
                this.migrationResult = `${count} records updated.`;
                this.migrationDone = true;
            } catch(error) {
                this.migrationError = error.message || 'Migration failed.';
            }
            this.isMigrating = false;
        }
    }
}
</script>
